import { DirectionalLight } from 'three';

let guiCount=0;
export function CreateLight(color:any,pos:any,intensity:any,hasGui:Boolean, scene:any, gui:any)
{
	const pointLight = new DirectionalLight( color );
	pointLight.position.set( pos.x, pos.y, pos.z );

	pointLight.intensity = intensity;
	
	// pointLight.castShadow = true;
	pointLight.shadow.mapSize.width = 1024;
	pointLight.shadow.mapSize.height = 1024;
	pointLight.shadow.normalBias = 0.05;

	pointLight.shadow.camera.near = 2;
	pointLight.shadow.camera.far = 30;
	// pointLight.color = 0x000000;
	scene.add(pointLight)

	// const spotLightCameraHelper = new THREE.CameraHelper(pointLight.shadow.camera);
	// scene.add(spotLightCameraHelper);

	if(hasGui){
		guiCount++;
		const lightFolder = gui.addFolder(`Light ${guiCount}`);
		lightFolder.add(pointLight.position, 'x', -50, 50);
		lightFolder.add(pointLight.position, 'y', -50, 50);
		lightFolder.add(pointLight.position, 'z', -50, 50);
		lightFolder.add(pointLight, 'intensity', -50, 50);
		// lightFolder.addColor(pointLight, 'color')
		lightFolder.open();
	}

	return pointLight;
}